/** BPM-5a: what the backend's `bpm_calculation_notes` says about the tariff it used.
 * Notes are `Key: value | Key: value`. Older releases carry no `Tariff` section. */
export function bpmTariffSummary(notes) {
  const tariff = String(notes || '').split(' | ').find(part => part.startsWith('Tariff: '))
  if (!tariff) return { tariff: null, isEstimate: false }
  const value = tariff.slice('Tariff: '.length)
  return {
    tariff: value.split(' (')[0].replace(/ passenger$/, '').trim() || null,
    isEstimate: value.includes('estimated_current_tariff'),
  }
}
